import React  from 'react'
import PropTypes from 'prop-types'

import EditableTextarea from "./textarea-inline-editable-new"

const ROW_HEIGHT = 20

export default class FieldRenderEditableInlineTextarea extends React.Component {

    static propTypes = {
        field               : PropTypes.object,
        value               : PropTypes.string,

        editClasses         : PropTypes.string,
        viewClasses         : PropTypes.string,
        rows                : PropTypes.number,

        disabled            : PropTypes.bool,

        onChange            : PropTypes.func,
        onImmediateChange   : PropTypes.func,
    }

    static defaultProps = {
        editClasses: "ui5-txt-default ui5-field-form-editable w-300 min-h-36 p-l-10 p-r-10 p-t-7 p-b-7",
        viewClasses: "ui5-txt-default ui5-field-input-hover-border w-300 min-h-36 p-l-10 p-r-10 p-t-7 p-b-7"
    }

    constructor(props) {
        super(props);

        this.value = this.props.value;
        this.renderState = 'view';
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (this.value !== nextProps.value) {
            this.value = nextProps.value;
        }
    }

    onClick = (e) => {
        if(e) e.stopPropagation();

        if (this.props.disabled) return

        this.renderState = 'edit';
        this.forceUpdate(()=>{
            this.input.focus();
            this.input.setCaretToEnd();
        })
    }

    onBlur = () => {
        this._switchToViewOnNextChange = true;
    }

    onChange = (value) => {
        this.value = value;
        this.renderState = this._switchToViewOnNextChange ? 'view' : 'edit';

        this.forceUpdate(()=>{
            if (this.props.onChange) this.props.onChange(value)
        })
    }

    render() {
        switch (this.renderState) {
            case 'edit':
                return (
                    <EditableTextarea ref               = {r=>this.input = r}
                                      className         = {this.props.editClasses}
                                      textareaClassName = "ui5-txt-default"
                                      value             = {this.value}
                                      icon              = {_.get(this.props.field.components, 'ValueIcon', false)}
                                      placeholder       = {this.props.field.placeholder}
                                      onBlur            = {this.onBlur}
                                      onChange          = {this.onChange}
                                      rows              = {this.props.rows}
                                      onImmediateChange = {this.props.onImmediateChange}/>
                );

            case 'view':
            default:
                const breakId = 'break_{0}'.f(gd.utils.guid());
                const viewValue = _.replace(this.value, /(?:\r\n|\r|\n)/g, breakId).split(breakId);

                let style = {}
                if (this.props.rows) {
                    style.minHeight = this.props.rows * ROW_HEIGHT
                }

                const isEmpty = !this.value && !!this.props.field.placeholder

                const classes = Classes(this.props.viewClasses, {
                    'ui5-txt-no-accent-default': isEmpty
                })

                if (isEmpty) return (
                    <div className={classes} onClick={this.onClick}>
                        <div className="ui5-field-view-value-multiline" style={style}>
                            {this.props.field.placeholder}
                        </div>
                    </div>
                )

                return (
                    <div className={this.props.viewClasses} onClick={this.onClick}>
                        <div className="ui5-field-view-value-multiline" style={style}>
                            {_.map(viewValue, (value,key)=>(
                                <React.Fragment key={key}>
                                    {value}
                                    <br/>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                )
        }
    }
}
